/**
 * Returns the base language code (e.g. en-GB -> en, es-MX -> es).
 * Use when passing language to APIs, formatters, or initial state.
 */
export function getBaseLanguage(lng: string): string {
  if (!lng || typeof lng !== 'string') {
    return 'en';
  }
  const base = lng.split('-')[0]?.toLowerCase();
  return base || 'en';
}
